import { FormattedMessage } from 'react-intl';
import Spinner from '../../../images/global/spinner.svg';

const ModuleLoadingSpinner = () => (
  <div className="module-loading-spinner">
    <div className="mls-spinner">
      <Spinner style={{ width: 24, height: 24, fill: '#2855c3' }} />
    </div>
    <div className="mls-message">
      <FormattedMessage defaultMessage="Loading ..." />
    </div>
  </div>
);

export default ModuleLoadingSpinner;
